import { Avatar, AvatarProps } from "@chakra-ui/react";
import { ProfileIcon } from "components/Icon/ProfileIcon";
import { User } from "features/User/models";
import ROLE from "models/role";

const CUSTOM_SIZES: Record<string, string> = {
  "3xs": "14px",
};

interface ProfileAvatarProps extends AvatarProps {
  user: User | undefined;
  role?: ROLE;
}

export default function ProfileAvatar({ user, role, size, ...props }: ProfileAvatarProps) {
  const borderColors = ["cdsIndigo.300", "cdsOrange.500", "caminoBlue.500"];
  const roleIndex = role && Object.values(ROLE).indexOf(role);
  const borderColor = props.borderColor || (user?.avatarUrl ? undefined : borderColors[roleIndex ?? 0]);
  const borderWidth = borderColor && 2;

  const customDim = typeof size === "string" ? CUSTOM_SIZES[size] : undefined;

  return (
    <Avatar
      src={user?.avatarUrl}
      bg="cdsIndigo.300"
      icon={<ProfileIcon fontSize="1.6rem" user={user} index={roleIndex} />}
      borderColor={borderColor}
      borderWidth={borderWidth}
      size={customDim ? "2xs" : size}
      {...(customDim ? { w: customDim, h: customDim, minW: customDim } : {})}
      {...props}
    />
  );
}
